import React from "react";

import {RplsCtrlApi} from "./generated/api";

import {axiosInstance, config, getConfig, serverUrl} from "./Utils";


const rplsCtrlApi = new RplsCtrlApi(config, serverUrl, axiosInstance);
export default class RplsCtrl extends React.Component {


    static getRpls(id, callback) {
        rplsCtrlApi.rplsGet(id).then((result) => {
            callback(result.data);
        });
    }

    static getCommune(id, callback) {
        rplsCtrlApi.rplsCommuneGet(id).then((result) => {
            callback(result.data);
        });
    }

    static getRplsRpls(id, callback) {
        rplsCtrlApi.rplsRplsGet(id).then((result) => {
            callback(result.data);
        });
    }



}
